import styled from "styled-components";
import { Flex, Type } from "discover.medical.react-component-library";

export const StyledWrap = styled(Flex)`
  text-align: center;
  margin-bottom: ${({ theme }) => theme.space.lg};
  padding-top: ${({ $isMobile }) => ($isMobile ? 0 : "1.3rem")};
  background-color: ${({ theme }) => theme.colors.secondary.base};
  background-size: cover;
  background-position: 90% center;

  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    padding-top: ${({ theme }) => theme.space.xl};
    padding-bottom: ${({ theme }) => theme.space.xl};
    background-position: center;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: ${({ theme }) => theme.space.xxxl} 0;
  }
`;

export const StyledHeading = styled(Type)`
  margin-bottom: ${({ theme }) => theme.space.sm};

  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    font-size: 2rem;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    font-size: 2.4rem;
    margin-bottom: 0;
    padding-bottom: 0;
  }
`;

export const StyledParagraph = styled(Type)`
  font-style: italic;
  margin-bottom: ${({ theme }) => theme.space.xxl};
  padding: 0 ${({ theme }) => theme.space.md};

  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    font-size: ${({ theme }) => theme.font.size.lg};
    margin-bottom: ${({ theme }) => theme.space.xl};
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    margin-top: 0;
  }
`;
export const StyledSearch = styled(Flex)`
  margin: 0 auto;
  height: 4rem;
  background-color: ${({ $isMobile, theme }) =>
    !$isMobile
      ? theme.colors.senary.light
      : "transparent"}; // 002f56 is origin color from design which is not included in RCL, but current one is the same
  padding: 0 1.25rem;

  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    max-width: 506px;
    height: 3rem;
    background-color: transparent;
    padding-right: 0;
    padding-left: 0;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    max-width: 650px;
    margin-top: 0;
  }
`;

export const StyledSearchLoader = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  width: 100%;
  height: ${({ theme }) => theme.space.xl};
  border-radius: 3px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem ${({ theme }) => theme.space.md};

  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    height: ${({ theme }) => theme.space.xxl};
  }
`;
